import './styles/site.css';

import React from 'react';
import ReactDOM from 'react-dom';

import { hashHistory } from 'react-router';
import { AppContainer } from 'react-hot-loader';
import { syncHistoryWithStore } from 'react-router-redux';

import configureStore from './store/configureStore';
import Root from './components/Root';

const store = configureStore();
const history = syncHistoryWithStore(hashHistory, store);

const render = (Component) => {
    ReactDOM.render(
        <AppContainer>
            <Component store={store} history={history}/>
        </AppContainer>,
        document.getElementById('app')
    );
};

render(Root);

if (module.hot) {
    module.hot.accept('./components/Root', () => render(Root));
}

/*** Stopping SP from submitting form in our app ***/
const form = document.getElementById('aspnetForm');
if (form) {
    setTimeout(function() {
        form.onsubmit = function(e) { e.stopPropagation(); return false; };
    }, 1000);
}



// WEBPACK FOOTER //
// ./src/index.js